<app-navbar></app-navbar>
<section class="bg-image">
    <div class="container">
        <div class="pt-3 pb-3" *ngIf="!fetchinData">
            <div class="row">
                <div class="col-md-3">
                    <div align="left" style="padding-left: 20px">
                        <p style="font-size: 26px; color: white;">Facilities</p>
                    </div>
                    <div class="list-group list-group-flush">
                        <ng-container *ngFor="let item of items">
                            <button
                                [class.active]="selectedItem === item.Url"
                                (click)="selectItem(item.Url)"
                                class="newA linkStyle list-group-item list-group-item-action"
                            >
                                {{ item.Name }}
                            </button>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-9">
                    <div style="min-height: 800px">
                        <div>
                            <h3 style="color: white;">{{ selectedItemName }}</h3>
                            <hr style="background-color: white;" />
                            <!-- English Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'others'
                                "
                            >
                                <ng-container
                                    *ngIf="others_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="others_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-fluid"
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                    [src]="
                                                    others_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                />
                                            </div>
                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                others_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('others')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'others'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            others_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'others'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of others_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            others_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Ysc Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem && selectedItem == 'FishAquarium'
                                "
                            >
                                <ng-container
                                    *ngIf="FishAquarium_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="FishAquarium_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    FishAquarium_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                FishAquarium_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('FishAquarium')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'FishAquarium'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            FishAquarium_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'FishAquarium'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of FishAquarium_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            FishAquarium_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Culture Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'library'
                                "
                            >
                                <ng-container
                                    *ngIf="library_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="library_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    library_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                library_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('library')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'library'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            library_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'library'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of library_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            library_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Scout Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'modernClassroom'
                                "
                            >
                                <ng-container
                                    *ngIf="modernClassroom_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="modernClassroom_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    modernClassroom_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                modernClassroom_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('modernClassroom')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'modernClassroom'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            modernClassroom_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'modernClassroom'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of modernClassroom_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            modernClassroom_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Knowledge Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'computer-lab'
                                "
                            >
                                <ng-container
                                    *ngIf="computer_lab_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container
                                    *ngIf="computer_lab_data != null"
                                >
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    computer_lab_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        float: left;
                                                        height: auto;
                                                        margin: 0px 15px 10px
                                                            0px;
                                                        width: 100%;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                computer_lab_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe(
                                                                'computer'
                                                            )
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'computer'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            computer_lab_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'computer'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of computer_lab_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            computer_lab_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Debate Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'playground'
                                "
                            >
                                <ng-container
                                    *ngIf="playground_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="playground_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    playground_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                playground_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('playground')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'playground'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            playground_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'playground'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of playground_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            playground_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Chess Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem && selectedItem == 'canteen'
                                "
                            >
                                <ng-container
                                    *ngIf="canteen_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="canteen_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    canteen_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                canteen_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('canteen')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'cantene'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            canteen_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'canteen'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of canteen_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            canteen_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Art Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem && selectedItem == 'transport'
                                "
                            >
                                <ng-container
                                    *ngIf="transport_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="transport_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    transport_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                transport_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('transport')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'transport'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            transport_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'transport'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of transport_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            transport_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Ecology Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'multipurposeShed'
                                "
                            >
                                <ng-container
                                    *ngIf="multipurposeShed_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="multipurposeShed_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    multipurposeShed_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                multipurposeShed_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('multipurposeShed')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'multipurposeShed'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            multipurposeShed_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'multipurposeShed'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of multipurposeShed_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            multipurposeShed_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Art and Hand writting Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'inDoorGames'
                                "
                            >
                                <ng-container
                                    *ngIf="inDoorGames_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container
                                    *ngIf="inDoorGames_data != null"
                                >
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    inDoorGames_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                inDoorGames_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe(
                                                                'inDoorGames'
                                                            )
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'inDoorGames'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            inDoorGames_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'inDoorGames'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of inDoorGames_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            inDoorGames_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Science Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'TailorShop'
                                "
                            >
                                <ng-container
                                    *ngIf="TailorShop_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="TailorShop_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    TailorShop_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                TailorShop_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('TailorShop')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'TailorShop'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            TailorShop_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'TailorShop'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of TailorShop_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            TailorShop_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Sports Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem &&
                                    selectedItem == 'vegetableAndFishMarket'
                                "
                            >
                                <ng-container
                                    *ngIf="vegetableAndFishMarket_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="vegetableAndFishMarket_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    vegetableAndFishMarket_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                vegetableAndFishMarket_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('vegetableAndFishMarket')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'vegetableAndFishMarket'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            vegetableAndFishMarket_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'vegetableAndFishMarket'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of vegetableAndFishMarket_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            vegetableAndFishMarket_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Math Club -->
                            <div
                                class="container"
                                *ngIf="
                                    selectedItem && selectedItem == 'gardenAndNursery'
                                "
                            >
                                <ng-container
                                    *ngIf="gardenAndNursery_data == null"
                                    class="spinner-overlay"
                                >
                                    <span class="fetching-data-text"
                                        >No Data Found</span
                                    >
                                </ng-container>
                                <ng-container *ngIf="gardenAndNursery_data != null">
                                    <div class="row justify-content-center">
                                        <article
                                            class="col-md-12 text-justify p-4"
                                        >
                                            <div>
                                                <img
                                                    alt="Message"
                                                    class="img-thumbnail img-fluid"
                                                    [src]="
                                                    gardenAndNursery_data
                                                            .ShowAttachments[0]
                                                            .FilePath
                                                    "
                                                    style="
                                                        height: 300px;
                                                        width: 100%;
                                                        object-fit: cover;
                                                        border-radius: 10px;
                                                    "
                                                />
                                            </div>

                                            <p
                                                style="text-align: justify"
                                                [innerHTML]="
                                                gardenAndNursery_data.DetailsEn
                                                "
                                            ></p>
                                        </article>
                                    </div>
                                    <div class="row" style="margin-top: 20px">
                                        <div class="faq-accordion">
                                            <ul class="accordion">
                                                <li class="accordion-item">
                                                    <a
                                                        (click)="
                                                            toggleMe('gardenAndNursery')
                                                        "
                                                        class="accordion-title"
                                                        href="javascript:void(0)"
                                                    >
                                                        <i
                                                            [ngClass]="
                                                                activeSection ===
                                                                'gardenAndNursery'
                                                                    ? 'fas fa-minus'
                                                                    : 'fas fa-plus'
                                                            "
                                                        ></i>
                                                        {{
                                                            gardenAndNursery_data.TitleEn
                                                        }}
                                                    </a>
                                                    <section
                                                        *ngIf="
                                                            activeSection ===
                                                            'gardenAndNursery'
                                                        "
                                                        class="blog-area gallery-section"
                                                    >
                                                        <div class="container">
                                                            <div
                                                                class="gallery-container"
                                                            >
                                                                <div
                                                                    class="gallery"
                                                                    *ngFor="
                                                                        let image of gardenAndNursery_data.ShowAttachments
                                                                    "
                                                                >
                                                                    <a
                                                                        class="gallery__item"
                                                                        [title]="
                                                                            image.alt
                                                                        "
                                                                    >
                                                                        <img
                                                                            [src]="
                                                                                image.FilePath
                                                                            "
                                                                            [alt]="
                                                                                image.alt
                                                                            "
                                                                            class="popup-btn"
                                                                        />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <p
                                                            style="
                                                                border: 1px
                                                                    solid black;
                                                                margin-top: 10px;
                                                                padding: 5px;
                                                            "
                                                            [innerHTML]="
                                                            gardenAndNursery_data.DetailsEn
                                                            "
                                                        ></p>
                                                    </section>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                            <!-- Ends New -->
                        </div>
                    </div>
                </div>
            </div>

            <br />
        </div>
        <div aria-hidden="true" *ngIf="fetchinData" class="col-lg-12 col-md-12">
            <h5 class="placeholder-glow">
                <span class="placeholder col-12" style="height: 200px"></span>
            </h5>
        </div>
    </div>
</section>

<!-- New -->
